import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  align-items: center;
  display: flex;
  padding: 11px 10px 3px;
`
